const doc = [({"en":({"js":({"admin":({"routes":({"contact_relationships":({"edit":({"the_relationship_was_saved":"The relationship was saved."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;